
import React from 'react';
import { Table, TableHeader, TableRow, TableHead, TableBody, TableCell } from '@/components/ui/table';
import { Badge } from '@/components/ui/badge';
import { format } from 'date-fns';
import { SalesData } from '@/utils/licenseService';
import SalesTableGroupedBySuperAdmin from './SalesTableGroupedBySuperAdmin';
import SalesTableGroupedByInstance from './SalesTableGroupedByInstance';

interface SalesTableProps {
  filteredData: SalesData[];
  groupBy: 'none' | 'superadmin' | 'instance';
}

const SalesTable: React.FC<SalesTableProps> = ({ filteredData, groupBy }) => {
  if (filteredData.length === 0) {
    return (
      <div className="rounded-md border">
        <Table>
          <TableHeader>
            <TableRow>
              <TableHead>Request #</TableHead>
              <TableHead>Fulfillment #</TableHead>
              <TableHead>Super Admin</TableHead>
              <TableHead>Instance</TableHead>
              <TableHead>Plan</TableHead>
              <TableHead>Date</TableHead>
              <TableHead>Amount</TableHead>
              <TableHead>Status</TableHead>
              <TableHead>Type</TableHead>
            </TableRow>
          </TableHeader>
          <TableBody>
            <TableRow>
              <TableCell colSpan={9} className="text-center py-4">
                No sales data found
              </TableCell>
            </TableRow>
          </TableBody>
        </Table>
      </div>
    );
  }

  if (groupBy === 'superadmin') {
    return <SalesTableGroupedBySuperAdmin filteredData={filteredData} />;
  }

  if (groupBy === 'instance') {
    return <SalesTableGroupedByInstance filteredData={filteredData} />;
  }

  // No grouping - show flat list
  return (
    <div className="rounded-md border">
      <Table>
        <TableHeader>
          <TableRow>
            <TableHead>Request #</TableHead>
            <TableHead>Fulfillment #</TableHead>
            <TableHead>Super Admin</TableHead>
            <TableHead>Instance</TableHead>
            <TableHead>Plan</TableHead>
            <TableHead>Date</TableHead>
            <TableHead>Amount</TableHead>
            <TableHead>Status</TableHead>
            <TableHead>Type</TableHead>
          </TableRow>
        </TableHeader>
        <TableBody>
          {filteredData.map((sale) => (
            <TableRow key={sale.id}>
              <TableCell className="font-medium text-blue-600">
                {sale.requestOrderNumber || `RO${sale.invoiceId.substring(4)}`}
              </TableCell>
              <TableCell className="font-medium text-green-600">
                {sale.fulfillmentOrderNumber || `RSO${sale.invoiceId.substring(4)}`}
              </TableCell>
              <TableCell>{sale.superAdminName}</TableCell>
              <TableCell>{sale.instanceName || 'N/A'}</TableCell>
              <TableCell>
                <div>{sale.planName}</div>
                <div className="text-sm text-gray-500 capitalize">{sale.billingCycle}</div>
              </TableCell>
              <TableCell>{format(new Date(sale.date), 'MM/dd/yyyy')}</TableCell>
              <TableCell>${sale.amount}</TableCell>
              <TableCell>
                <Badge
                  variant={
                    sale.status === 'paid' ? 'default' :
                    sale.status === 'pending' ? 'outline' : 'destructive'
                  }
                >
                  {sale.status.charAt(0).toUpperCase() + sale.status.slice(1)}
                </Badge>
              </TableCell>
              <TableCell>
                <Badge variant="secondary">
                  {sale.isRecurring ? 'Recurring' : 'New'}
                </Badge>
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </div>
  );
};

export default SalesTable;
